export default {
  getProfileInfo(state) {
    return state.profileInfo;
  },
};
